import { Layout } from '@kanda-libs/ks-design-library';

import { BacsPaymentForm, JobButton, MobileHeader } from 'components';

import CantFindBankButton from '../components/CantFindBankButton';
import { PayByBacsPropsHook } from '../usePayByBacsProps';

const MobileBacs: React.FunctionComponent<PayByBacsPropsHook> = function (
  props,
) {
  return (
    <Layout header={<MobileHeader showCloseButton />} noBorder>
      <JobButton compact />
      <div className="mb-10" />
      <BacsPaymentForm {...props} showHeading />
      <CantFindBankButton />
    </Layout>
  );
};

export default MobileBacs;
